module.exports = __webpack_public_path__ + "static/media/medical-certificate.d6fa7c96.svg";